module.exports = __webpack_public_path__ + "img/bg_multitle_table.d6951016.png";